import { render, staticRenderFns } from "./PublicationHistory.vue?vue&type=template&id=152961c2&scoped=true&"
import script from "./PublicationHistory.vue?vue&type=script&lang=js&"
export * from "./PublicationHistory.vue?vue&type=script&lang=js&"
import style0 from "./PublicationHistory.vue?vue&type=style&index=0&id=152961c2&lang=scss&scoped=true&"
import style1 from "./PublicationHistory.vue?vue&type=style&index=1&id=152961c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152961c2",
  null
  
)

export default component.exports